<!-- Contenedor general -->
<div class="flex flex-col gap-5 w-full p-4">
  
  <!-- Título principal alineado a la izquierda -->
  <div class="flex w-full justify-start mb-2 px-2">
    <p class="text-general-title color-blue text-left">
      {{ 'Linea de arrendamiento' | translate }}
    </p>
  </div>

  <div class="general-simple-box p-3 xl:p-6 flex flex-col w-full!">
    <!-- FORMULARIO ÚNICO ENVOLVIENDO AMBAS COLUMNAS -->
    <form [formGroup]="customerFormGroup" class="w-full">
      <!-- GRID: Contenedor de las dos columnas -->
      <div class="grid gap-6 w-full"
        [ngClass]="{
          'grid-cols-1': clientSectionColumm === 1,
          'grid-cols-1 lg:grid-cols-2 ': clientSectionColumm === 2
        }">
        
        <!-- ========================================== -->
        <!-- COLUMNA 1: DATOS DEL CLIENTE               -->
        <!-- ========================================== -->
        <div class="aa-input-general w-full">
          <div class="text-general-title mb-2 text-(--color-segundo)">
            {{ 'quotation.titles.clientData' | translate }}
          </div>

          <div class="flex flex-col gap-1">
            
            <!-- TIPO DE PERSONA -->
            <div class="subtitle-content gap-1 flex flex-col">
              <app-input-general-select
                class="w-full"
                [formControlGeneral]="customerFormGroup.controls['personType']"
                [label]="'quotation.fieldNames.personType' | translate"
                [placeholder]="'quotation.fieldNames.personType' | translate"
                [arrayData]="personTypes"
                [inputSelect]="{ value: 'id', description: 'description' }"
                (selectionChange)="onChangePersonType($event)"
              ></app-input-general-select>
            </div>

            <!-- RFC / TIN -->
            <div class="subtitle-content gap-1 flex flex-col">
              <app-input-general
                class="w-full"
                [formControlGeneral]="customerFormGroup.controls['TIN']"
                [label]="'quotation.fieldNames.TIN' | translate"
                [placeholder]="'quotation.fieldNames.TIN' | translate"
              ></app-input-general>
            </div>

            <!-- NOMBRE O RAZÓN SOCIAL -->
            <div class="subtitle-content gap-1 flex flex-col">
              <app-input-general
                class="w-full"
                [formControlGeneral]="customerFormGroup.controls['firstName']"
                [label]="'quotation.fieldNames.nameOrCompanyName' | translate"
                [placeholder]="'quotation.fieldNames.nameOrCompanyName' | translate"
              ></app-input-general>
            </div>

            <!-- CAMPOS CONDICIONALES -->
            @if (customerFormGroup!.get('personType')!.value !== 3) {
              <div class="subtitle-content gap-1 flex flex-col">
                <app-input-general
                  class="w-full"
                  [formControlGeneral]="customerFormGroup.controls['lastName']"
                  [label]="'quotation.fieldNames.lastName' | translate"
                  [placeholder]="'quotation.fieldNames.lastName' | translate"
                ></app-input-general>
              </div>

              <div class="subtitle-content gap-1 flex flex-col">
                <app-input-general
                  class="w-full"
                  [formControlGeneral]="customerFormGroup.controls['secondLastName']"
                  [label]="'quotation.fieldNames.secondLastName' | translate"
                  [placeholder]="'quotation.fieldNames.secondLastName' | translate"
                ></app-input-general>
              </div>
            }

            <!-- TELÉFONO -->
            <div class="subtitle-content gap-1 flex flex-col">
              <app-input-general
                class="w-full"
                [formControlGeneral]="customerFormGroup.controls['phoneNumber']"
                [label]="'quotation.fieldNames.phoneNumber' | translate"
                [placeholder]="'quotation.fieldNames.phoneNumber' | translate"
                [mask]="'(000) 000-0000'"
              ></app-input-general>
            </div>

            <!-- CORREO -->
            <div class="subtitle-content gap-1 flex flex-col">
              <app-input-general
                class="w-full"
                [formControlGeneral]="customerFormGroup.controls['email']"
                [label]="'quotation.fieldNames.email' | translate"
                [placeholder]="'quotation.fieldNames.email' | translate"
              ></app-input-general>
            </div>
          </div>
        </div>

        <!-- ========================================== -->
        <!-- COLUMNA 2: LÍNEA DE ARRENDAMIENTO          -->
        <!-- ========================================== -->
        <div class="aa-input-general w-full">
          <div class="text-general-title mb-2 text-(--color-segundo)">
            {{ 'quotation.titles.leaseLineData' | translate }}
          </div>

          <div class="flex flex-col gap-1">
            
            <!-- MONTO -->
            <div class="subtitle-content gap-1 flex flex-col">
              <app-input-general
                class="w-full"
                [formControlGeneral]="customerFormGroup.controls['totalAmount']"
                [label]="'quotation.fieldNames.amount' | translate"
                [placeholder]="'quotation.fieldNames.amount' | translate"
                [mask]="'separator.2'" 
                thousandSeparator="," 
                prefix="$ "
              ></app-input-general>
            </div>

            <!-- TASA -->
            <div class="subtitle-content gap-1 flex flex-col">
              <app-input-general
                class="w-full"
                [formControlGeneral]="customerFormGroup.controls['rate']"
                [label]="'quotation.fieldNames.rate' | translate"
                [placeholder]="'quotation.fieldNames.rate' | translate"
              ></app-input-general>
            </div>

            <!-- PLAZO (AQUÍ ES DONDE SE APLICÓ EL CAMBIO PRINCIPAL) -->
            <div class="subtitle-content gap-1 flex flex-col">
              <app-input-general-select
                class="w-full"
                [formControlGeneral]="customerFormGroup.controls['term']"
                [label]="'general-pages.analysis.term' | translate"
                [placeholder]="'general-pages.analysis.term' | translate"
                [arrayData]="listDeadlines?.deadlines || []"
                [inputSelect]="{ value: 'id', description: 'description' }"
              ></app-input-general-select>
            </div>

            <!-- BOTÓN ENVIAR -->
            <div class="flex justify-center items-center gap-4 px-4 mt-4">
              <button
                type="button"
                [disabled]="customerFormGroup.invalid"
                mat-button
                (click)="sendToIntegration()"
                class="button-general text-center w-auto! h-12.75 mt-2"
              >
                {{ 'quotation.fieldNames.sendToIntegration' | translate }}
              </button>
            </div>

          </div>
        </div>
        
      </div>
    </form>
  </div>
</div>